<!-- WonderYjjPopular.vue -->
<template>
	<div>
		<div class="row">
			<template v-if="days.length">
				<PopularPlate v-for="(day, index) in days" :date1="day" :key="index" :plate_type=25
					:selectedPlateCode="selectedPlateCode" :selectedPlateName="selectedPlateName" @plate-selected="handlePlateSelected">
				</PopularPlate>
			</template>
		</div>
		<div class="row">
			<div class="col col-md-2 col-sm-3" v-if="selectedPlateCode">
				<PlateStockPopular :plate_type=25 :plate_code="selectedPlateCode" :p_date=selectedDate
					@p_show_kline="handleShowKline" @date-selected="handleDateSelected">
				</PlateStockPopular>
			</div>
			<div class="col col-md-10 col-sm-9">
				<StockKlineDay v-if="selectedPlateCode" :symbol_code="selectedPlateCode" :title="selectedPlateName" :subText="selectedPlateCode"
					:chart_heigh="'400px'" :zoom_start=40 :highlightDate="selectedDate"></StockKlineDay>

				<StockMultiChart v-if="symbol_code" :symbol_code="symbol_code" :symbol_name="symbol_name"
					:selectedDate="selectedDate" :chart_width="'900px'">
				</StockMultiChart>

			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import PopularPlate from 'components/plate/PopularPlate.vue'
	import PlateStockPopular from 'components/plate/PlateStockPopular.vue'
	import StockMultiChart from 'components/stock/StockMultiChart.vue'
	import StockKlineDay from 'components/stock/StockKlineDay.vue'

	import {
		request_zzquant
	} from "network/request.js"
	// import SentimentMarketHotTrend from 'components/sentiment/SentimentMarketHotTrend.vue'
	export default {
		data() {
			return {
				selectedPlateCode: null,
				selectedPlateName: null,
				days: [],
				dayn: 10,
				symbol_name: "",
				symbol_code: null,
				selectedDate: null,
			};
		},
		created() {
			const days_n = this.$route.params.dayn || 10 // 如果 URL 参数 dayn 不存在，使用 '10' 作为默认值
			this.dayn = days_n
		},
		mounted() {
			this.get_trade_days();
		},
		components: {
			PopularPlate,
			PlateStockPopular,
			StockMultiChart,
			StockKlineDay
		},
		methods: {
			handleDateSelected(newDate) {
				this.selectedDate = newDate; // Update selectedDate when the date-selected event is emitted
			},
			handlePlateSelected(plateCode, plateName) {
				// 处理选中的板块
				// console.log(plateCode, plateName)
				this.selectedPlateCode = plateCode
				this.selectedPlateName = plateName	
			},
			handleShowKline(symbol_code) {
				this.symbol_code = symbol_code
				// console.log(symbol_code)
			},
			get_trade_days() {
				const today = (() => {
					const now = moment();
					const currentTime = now.format('HH:mm');					
					if (currentTime < '09:31'){
						return now.format('YYYY-MM-DD');
					} else {
						return now.add(1, 'days').format('YYYY-MM-DD');
					}
				})();
				request_zzquant({
						url: '/market/trade/days?day_end=' + today + '&days=' + this.dayn
					})
					.then(res1 => {
						// console.log(res1['data']['data']);
						this.days = res1['data']['data'].slice().reverse();
						this.selectedDate = this.days[1]
					})
					.catch(err => {
						console.log(err);
					});
			}
		}
	}
</script>

<style>
</style>